import script from "./work_content.vue?vue&type=script&setup=true&lang=js"
export * from "./work_content.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__